import * as React from 'react';
import {BaseIconProps} from '../../types';

export const BaseCopyFilled: React.FC<BaseIconProps> = ({size, color}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 2.5H5C3.61929 2.5 2.5 3.61929 2.5 5V14C2.5 15.3807 3.61929 16.5 5 16.5H6V10C6 7.79086 7.79086 6 10 6H16.5V5C16.5 3.61929 15.3807 2.5 14 2.5ZM10 7.5H19C20.3807 7.5 21.5 8.61929 21.5 10V19C21.5 20.3807 20.3807 21.5 19 21.5H10C8.61929 21.5 7.5 20.3807 7.5 19V10C7.5 8.61929 8.61929 7.5 10 7.5Z"
        fill={color}
      />
    </svg>
  );
};
